import { AddContactForm, ContactsList } from 'components';

export const Contacts = () => {
  return (
    <>
      <AddContactForm />
      <ContactsList />
    </>
  );
};
